/* @flow */
import Dispatch from "nexia_mobile/flux_like/dispatch";
import Store, { setValueAtPath } from "nexia_mobile/flux_like/store";
import Platform from "nexia_mobile/platform";
import LocalSettings, {
  AUTH_TYPES,
  AUTH_LOCKOUT_MINUTES,
} from "nexia_mobile/models/local_settings";
import { clearHistoryAndPush } from "nexia_mobile/history";
import { getLanguageSet } from "nx-components/Locales";

Dispatch.on("SAVE_NEW_PIN", (pinCode) => {
  LocalSettings.saveNewPin(pinCode);
  setValueAtPath("appState.userAuthenticated", true);
  // Default new logins to PIN, or fingerprint if available
  if (LocalSettings.getCurrentAuth() === AUTH_TYPES.UNINITIALIZED) {
    LocalSettings.setAuthToPin();
    Platform.isFingerprintAuthAvailable()
      .then((hasFingerprint) => {
        if (hasFingerprint) {
          LocalSettings.setAuthToFingerprint();
        }
      })
      .catch(() => {
        // ignore platform bridge error
      });
  }
  clearHistoryAndPush("/app");
});

Dispatch.on("VALIDATE_PIN", (pinCode) => {
  const localeSet = getLanguageSet();
  const language = localeSet.nexia_mobile.utils.flux_like.pin;
  if (LocalSettings.isPinValid(pinCode)) {
    LocalSettings.clearFailedAuthAttempts();
    Platform.sendGoogleAnalyticsEvent("login", "pin_entry", "success");
    setValueAtPath("appState.userAuthenticated", true);
    clearHistoryAndPush("/app");
  } else {
    LocalSettings.recordFailedAuthAttempt();
    setValueAtPath(
      "isAuthAttemptLockedOut",
      LocalSettings.isAuthAttemptLockedOut()
    );
    if (Store.isAuthAttemptLockedOut) {
      setTimeout(
        () => Dispatch("AUTH_LOCKOUT_ENDED"),
        AUTH_LOCKOUT_MINUTES * 60 * 1000
      );
    }
    Platform.sendGoogleAnalyticsEvent("login", "pin_entry", "error");
    Dispatch("SHOW_TOAST", language.invalidPinToast);
  }
});

Dispatch.on("AUTH_LOCKOUT_ENDED", () => {
  LocalSettings.clearFailedAuthAttempts();
  setValueAtPath(
    "isAuthAttemptLockedOut",
    LocalSettings.isAuthAttemptLockedOut()
  );
});

Dispatch.on("PIN_RESET", () => {
  LocalSettings.clearPin();
  setValueAtPath("appState.userAuthenticated", false);
  clearHistoryAndPush("/pin-entry/create", { isPinReset: true });
});



// WEBPACK FOOTER //
// ./src/flux_like/action_handlers/pin.js